import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  getClientPage,
  getMyUserGroupPage,
  exportExcel,
  addProcessRemark,
} from '@/api/cndtriprecordanalysisresultserv'

export default {
  state: {
    state_CnDTripRecordAnalysisResult_GetAllResult: null,
    state_CnDTripRecordAnalysisResult_SearchByNameResult: null,
    state_CnDTripRecordAnalysisResult_GetPageResult: null,
    state_CnDTripRecordAnalysisResult_GetDetailResult: null,
    state_CnDTripRecordAnalysisResult_GetClientPageResult: null,
    state_CnDTripRecordAnalysisResult_GetMyUserGroupPageResult: null,
    state_CnDTripRecordAnalysisResult_ExportExcelResult: null,
    state_CnDTripRecordAnalysisResult_AddProcessRemarkResult: null,
  },
  mutations: {
    SET_CNDTRIPRECORDANALYSISRESULT_GETALL_RESULT: (state, rst) => {
      state.state_CnDTripRecordAnalysisResult_GetAllResult = rst;
    },
    SET_CNDTRIPRECORDANALYSISRESULT_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_CnDTripRecordAnalysisResult_SearchByNameResult = rst;
    },
    SET_CNDTRIPRECORDANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_CnDTripRecordAnalysisResult_GetPageResult = rst;
    },
    SET_CNDTRIPRECORDANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_CnDTripRecordAnalysisResult_GetDetailResult = rst;
    },
    SET_CNDTRIPRECORDANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_CnDTripRecordAnalysisResult_GetClientPageResult = rst;
    },
    SET_CNDTRIPRECORDANALYSISRESULT_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_CnDTripRecordAnalysisResult_GetMyUserGroupPageResult = rst;
    },
    SET_CNDTRIPRECORDANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_CnDTripRecordAnalysisResult_ExportExcelResult = rst;
    },
    SET_CNDTRIPRECORDANALYSISRESULT_ADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_CnDTripRecordAnalysisResult_AddProcessRemarkResult = rst;
    },
  },
  actions: {
    CnDTripRecordAnalysisResultServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CnDTripRecordAnalysisResultServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CnDTripRecordAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CnDTripRecordAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CnDTripRecordAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CnDTripRecordAnalysisResultServ_GetMyUserGroupPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_GETMYUSERGROUPPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_GETMYUSERGROUPPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CnDTripRecordAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CnDTripRecordAnalysisResultServ_AddProcessRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addProcessRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_ADDPROCESSREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CNDTRIPRECORDANALYSISRESULT_ADDPROCESSREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_CnDTripRecordAnalysisResult_GetAllResult: state => {
      return state.state_CnDTripRecordAnalysisResult_GetAllResult;
    },
    get_CnDTripRecordAnalysisResult_SearchByNameResult: state => {
      return state.state_CnDTripRecordAnalysisResult_SearchByNameResult;
    },
    get_CnDTripRecordAnalysisResult_GetPageResult: state => {
      return state.state_CnDTripRecordAnalysisResult_GetPageResult;
    },
    get_CnDTripRecordAnalysisResult_GetDetailResult: state => {
      return state.state_CnDTripRecordAnalysisResult_GetDetailResult;
    },
    get_CnDTripRecordAnalysisResult_GetClientPageResult: state => {
      return state.state_CnDTripRecordAnalysisResult_GetClientPageResult;
    },
    get_CnDTripRecordAnalysisResult_GetMyUserGroupPageResult: state => {
      return state.state_CnDTripRecordAnalysisResult_GetMyUserGroupPageResult;
    },
    get_CnDTripRecordAnalysisResult_ExportExcelResult: state => {
      return state.state_CnDTripRecordAnalysisResult_ExportExcelResult;
    },
    get_CnDTripRecordAnalysisResult_AddProcessRemarkResult: state => {
      return state.state_CnDTripRecordAnalysisResult_AddProcessRemarkResult;
    },
  }
}